export default __webpack_public_path__ + "static/media/bra-logo-antes.3a7b4677.webp";